import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=1633063c"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/serbanhoratiutudor/Projects/genie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1633063c')) {
      api.createRecord('1633063c', component.options)
    } else {
      api.reload('1633063c', component.options)
    }
    module.hot.accept("./Auth.vue?vue&type=template&id=1633063c", function () {
      api.rerender('1633063c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Auth.vue"
export default component.exports